import { compose } from '../utils/func';
import Datum from '../Datum';
import DList from './List';
import BaseItem from './BaseItem';
import Pagination from './Pagination';
var bindKeys = ['disabled', 'limit', 'format', 'prediction', 'distinct'];
var List = compose(Datum.hoc({
  bindProps: bindKeys,
  ignoreUndefined: true,
  setValueType: null,
  pure: false
}), Pagination)(DList);
List.BaseItem = BaseItem;
export default List;